import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import { StyledTable, TableWrapper } from './Table.styled'

const Table = ({ intlKey, titleID, textID, headers, rowHeaders, rows }) => {
  const captionID = 'caption-' + Math.random().toString(36).substr(2, 9)
  return (
    <TableWrapper>
      <StyledTable
        className='table-container'
        role='group'
        aria-labelledby={captionID}
      >
        <figure>
          <table>
            <caption id={captionID}>
              <FormattedHTMLMessage
                id={intlKey + titleID}
                key={intlKey + titleID}
              />
            </caption>
            {headers.length > 0 && (
              <thead>
                <tr>
                  {headers.map((header, i) => (
                    <th scope='col' key={i}>
                      <FormattedHTMLMessage
                        id={intlKey + header}
                        key={intlKey + header}
                      />
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, i) =>
                    rowHeaders && i < 1 ? (
                      <th scope='row' key={i}>
                        <FormattedHTMLMessage
                          id={intlKey + cell}
                          key={intlKey + cell}
                        />
                      </th>
                    ) : (
                      <td key={i}>
                        <FormattedHTMLMessage
                          id={intlKey + cell}
                          key={intlKey + cell}
                        />
                      </td>
                    )
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          <figcaption>
            <FormattedHTMLMessage
              id={intlKey + captionID}
              key={intlKey + captionID}
            />
          </figcaption>
        </figure>
      </StyledTable>
    </TableWrapper>
  )
}

export default Table
